import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from '../constants';
import { MenuDetailsV2Response, MenuDetailsV2Data } from './types';

export type MenuDetailsV2Includes = 'sections' | 'items' | 'modifier_groups' | 'mealtimes' | 'prices' | 'all';

interface GetMenuDetailsV2Options {
  menuId: string;
  includes?: MenuDetailsV2Includes[];
}

/**
 * Fetches menu details from the V2 endpoint with selective field inclusion.
 * @param options - menuId and optional includes array
 * @returns Menu data with requested fields
 */
export const getMenuDetailsV2 = async ({
  menuId,
  includes = ['sections', 'items', 'modifier_groups'],
}: GetMenuDetailsV2Options): Promise<MenuDetailsV2Data> => {
  const includesParam = includes.join(',');
  const url = `${API_URL}/menus/${menuId}/details/v2?includes=${includesParam}`;

  const res = await fetch(url);

  if (!res.ok) {
    throw new Error('Failed to fetch menu details');
  }

  const response: MenuDetailsV2Response = await res.json();

  if (response.data.length === 0) {
    throw new Error('Menu details returned empty data array');
  }

  return response.data[0];
};
